<template>
  <div class="diadin">

    <div class="title">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item>
          <el-input :placeholder="$t('menu.Title')" clearable v-model="formInline.title"></el-input>

        </el-form-item>
        <el-form-item   v-if="shenf=='1'"> 
         <el-select v-model="formInline.retailerId" :placeholder="$t('menu.zcmxlsh')" clearable filterable >
        
          <el-option v-for="(item, index) in cartypelist" :key="index" :label="item.dealerName" :value="item.id" ></el-option>
        </el-select>
        
          <!-- <el-button type="primary" @click="search">{{ $t('menu.search') }}</el-button> -->
        </el-form-item>
         <el-form-item>
          <el-select class="cinput" v-model="formInline.type" :placeholder="$t('menu.Type') "
            clearable>
            <el-option  v-for="(item, index) in titleList" :key="index" :label="item.dictLabel"
              :value="item.dictValue"></el-option>
           

          </el-select>
          <el-button type="primary" @click="search">{{ $t('menu.search') }}</el-button>
        </el-form-item>
      </el-form>
      <div>
        
      </div>
      
       <el-upload
           v-if="shenf=='1'"
               class="upload-demo"
                action="#"
                :http-request="uploadFile"
               :on-preview="handlePreview"
               :on-remove="handleRemove"
               :before-remove="beforeRemove"
               :show-file-list="false"
               multiple
               :limit="99"
               :on-exceed="handleExceed"
               :file-list="fileupList">
               <el-button    size="small" type="primary">{{ $t('menu.fbwdsc') }}{{ $t('menu.fapiao') }} </el-button>
               <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
              </el-upload>
              <el-button size="mini" type="primary"  v-if="shenf=='2'"   @click="sscxc()">{{ $t('menu.Download') }}
              <!-- <a :href="ncodeUrlPath(scope.row.url)" :download="`${scope.row.title} ` + '.' + typ">{{ $t('menu.Download') }}</a>  v-if="shenf=='2'"-->
            </el-button>
              
    </div>




    <el-table  empty-text=" " :data="mation" style="width: 100%" stripe border highlight-current-row   @selection-change="handleSelectionChange">
         <el-table-column
         v-if="shenf=='2'"
      type="selection"
      width="55">
      </el-table-column>
      <el-table-column prop="title" :label="$t('menu.Title')">
        <template slot-scope="scope">
        
          {{ scope.row.title }}
        </template>
      </el-table-column>
       <el-table-column prop="type" :label="$t('menu.Type')">
        <template slot-scope="scope">
         {{ formatChea(scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column   v-if="shenf=='1'" prop="retailerName" :label="$t('menu.zcmxlsh')"> </el-table-column>
      <el-table-column prop="time" :label="$t('menu.Time')" width="280"> </el-table-column>
      <el-table-column prop="vin" width="300" :label="$t('menu.Operation')">
        <template slot="label">
          <div>{{ $t('menu.Operation') }}</div>
        </template>

        <template slot-scope="scope">
          <div class="btn">
          
              
            <el-button type="text" size="mini" @click="downurl(scope.row, formatTitle(scope.row))">{{ $t('menu.Preview')
              }}</el-button>

            <el-button type="text" size="mini" >
              <a :href="ncodeUrlPath(scope.row.url)" :download="`${scope.row.title} ` + '.' + typ">{{ $t('menu.Download') }}</a>
            </el-button>
             <el-button   v-if="shenf=='1'" type="text" style="color: red;" size="mini" @click="deleup(scope.row)">{{ $t('menu.Delete') }}</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="bottompage">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage3"
        :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" layout="total,sizes, prev, pager, next" :total="totale">
      </el-pagination>

    </div>

    <div></div>
    <el-dialog :title="ylTitle" :visible.sync="dialogVisible" width="80%" :before-close="handleClose">
    
      <div v-if="typ == 'txt'" v-html="txtUrl">

      </div>
      <video v-if="typ == 'mp4'" controls>
        <source :src="videoUrl" type="video/mp4">
      </video>

      <!-- <iframe v-if="typ == 'pdf'" :src="videoUrl"  width="100%" height="800px" /> -->

     <yl v-if="typ == 'pdf'" :url="videoUrl" :typ="'pdf'"></yl>
    
     <yl v-if="typ == 'PDF'" :url="videoUrl" :typ="'pdf'"></yl>
    
      <!-- <iframe v-if="typ == 'pdf'" :src="videoUrl"  width="100%" height="800px" /> -->
       <!-- <iframe v-if="typ == 'pdf'"  frameborder="0" :src="videoUrl"  width="100%" height="800px" /> -->
      <yl v-if="typ == 'xlsx'" :url="aurl" :typ="'xlsx'"></yl>
      <yl v-if="typ == 'docx'" :url="aurl" :typ="'docx'"></yl>
      <yl v-if="typ == 'excel'" :url="aurl" :typ="'excel'"></yl>
      <img v-if="typ == 'png' || typ == 'jpg' || typ == 'jepg'" :src="imgurl" alt="">
      <iframe v-if="typ !== 'png' && typ !== 'jpg' && typ !== 'jepg' && typ !== 'mp4' && typ !== 'txt' && typ !== 'pdf'&& typ !== 'xlsx'&& typ !== 'docx'&& typ !== 'excel'&& typ !== 'PDF'"
        :src='aurl' style="width: 100%; height: 70vh" frame />
    </el-dialog>
   

  </div>
</template>
<script type="text/javascript" src="https://cdn.jsdelivr.net/npm/js-base64@3.6.0/base64.min.js"></script>
<script>
import { InvoiceOfDealer,retailerlist, InvoiceOfDealeradd,deleInvoiceOfDealer } from "../../api/api";
import axios from "axios"
import yl from '../../components/yl' //发票
export default {
   components: {
    yl
   
  },
  data () {
    return {
      currentPage3: 1,
      dialogVisible: false,
      
      uptitlename: this.$t('menu.fabuwendang'), 
      pagesize: 10,
      aurl: '',
      totale: 3,
      activeName: "first",
      mation: [], //列表
      fileupList:[],
      action: this.$t('menu.All'),
      titleList: [
        {
          dictValue: '',
          dictLabel: this.$t('menu.All')
        },
         {
          dictValue: '9000',
          dictLabel:this.$t('menu.zhoubianq')
        },
         {
          dictValue: '0',
          dictLabel: this.$t('menu.Parts')
        },
         {
          dictValue: '1',
          dictLabel:this.$t('menu.erlunpej')
        },
         {
          dictValue: '2',
          dictLabel: this.$t('menu.erlunzhengc')
        },
         {
          dictValue: '3',
          dictLabel: this.$t('menu.silunpej')
        },
         {
          dictValue: '4',
          dictLabel: this.$t('menu.silunzhengc')
        }
      ],
      
      upform:{
        fileName:'',
        category:'',
        mcSeriesModel:'',
        filePath:'',
        
      },
      formInline: {
        title: "",
      
        type: "",
        retailerId: '',
      },
      inle: 'zh',
      ylTitle: '',
      a: false,
      b: false,
      cheList: [],
      txtUrl: '',
      typ: '',
      videoUrl: '',
      imgurl: '',
      cartypelist:[],
      shenf:'1',
      multipleSelection:[]
    };
  },
  created () {
    let a = sessionStorage.getItem('i18n')
    this.inle = a
    this.shenf=sessionStorage.getItem('platform')
    this.biao();
   this.getQuerytype()
    

  },
  methods: {
    handleSelectionChange(val){
         this.multipleSelection = val;
         console.log(this.multipleSelection);
         
    },
       downLoada (row) {
      console.log(row)
      // const fileURL = 'https://dms.bendamoto.com/bendaFDMSWeb' + row.filePath; // 替换为你的文件URL
      const fileURL =  row.url; // 替换为你的文件URL
      // console.log(fileURL)
      // const link = document.createElement('a');
      // // 这里是将链接地址url转成blob地址，
      // fetch(fileURL).then(res => res.blob()).then(blob => {
      //   link.href = URL.createObjectURL(blob)
      //   // 下载文件的名称及文件类型后缀
      //   link.download = `${row.fileName} ` + '.' + this.typ;
      //   document.body.appendChild(link)
      //   link.click()
      //   //在资源下载完成后 清除 占用的缓存资源
      //   window.URL.revokeObjectURL(link.href);
      //   document.body.removeChild(link);
      // });

      const src = `${fileURL}?t=${new Date().getTime()}`
      fetch(src).then(res => {
        res.blob().then(myBlob => {
          const href = URL.createObjectURL(myBlob)
          const a = document.createElement('a')
          a.href = href
          a.download = `${row.title} `;
          a.click()
          a.remove()
        })
      })
    

    },
    sscxc(){
      // 
      if(this.multipleSelection.length>0){
        this.multipleSelection.forEach(e=>{
          e.url=this.ncodeUrlPath(e.url)
           this.downLoada(e)
        })
       
      }
    },
     ncodeUrlPath(url) {
  // 找到最后一个 '/' 的位置
  const lastSlashIndex = url.lastIndexOf('/');

  // 如果没有找到 '/', 直接返回原字符串
  if (lastSlashIndex === -1) {
    return url;
  }

  // 提取最后一个 '/' 之前的部分（包括 '/'）
  const prefix = url.substring(0, lastSlashIndex + 1);

  // 提取最后一个 '/' 之后的部分（文件名）
  const fileName = url.substring(lastSlashIndex + 1);

  // 对文件名部分进行 encodeURIComponent 转码
  const encodedFileName = encodeURIComponent(fileName);

  // 拼接返回
  return prefix + encodedFileName;
},
   //零售商
    getQuerytype () {
 
      const params = new URLSearchParams()
      retailerlist( params, 1,1000).then(r => {
        console.log(r);
        this.cartypelist = r.data.rows;
    
      })
    },
    //删除
    deleup(e){
      let param = new URLSearchParams();
      deleInvoiceOfDealer(param,e.id).then(res=>{
        if(res.data.code == '200'){
          this.$message.success('删除完成')
        this.biao()
        } else {
          this.$message.error(res.data.message)
        }
      })
    },

  
     uploadFile(file){
      console.log(file);
      
      let formdata = new FormData()
      formdata.append('file',file.file)
      //  formdata.append('category',file.file.type)
      // formdata.append('title',file.file.type)
      InvoiceOfDealeradd(formdata).then(res=>{
        if(res.data.code == '200'){
          this.$message.success('上传成功')
           let a ={
              name:file.file.name,
              url:res.data.data
          }
          this.fileupList.push(a)
           this.fileupList=[]
            this.biao()
        } else {
          this.$message.error(res.data.msg)
           this.fileupList=[]
            this.biao()
        }
      })
    },
     handleRemove(file, fileList) {
        console.log(1);
      },
      handlePreview(file) {
        console.log(2);
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 100 个文件`);
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`).then( ()=> {
          this.fileupList=[]
          console.log(123,this.fileupList );
          
        })

      },
    formatTitle (row) {

      let str = row.url
      let b = ''
      if (row !== ''&&str!==null) {

        b = str.substring(str.lastIndexOf(".") + 1, str.length);
        // console.log(b)
      }
      return b
    },
    handleClose (done) {
      this.upform={
              fileName:'',
              category:'',
              mcSeriesModel:'',
              filePath:'',
            }
            this.dialogVisible=false
    
       this.biao()

    },
    formatChe (ids) {
       let arr = ''
      if( typeof ids === 'string'){
           arr = ids.split(',')
      }else{
        arr = ids
      }
     
      let str = []
      arr.forEach(item => {
        // console.log(item)
        this.cheList.forEach(i => {
          // console.log(i)
          if (item == i.id && this.inle == 'zh') {
            str.push(i.seriesModel)
          }
          if (item == i.id && this.inle !== 'zh') {
            str.push(i.seriesModelEn)
          }
        })
      })
      // console.log(str)
      return str.join(',')
    },
    formatChea (ids) {
      let arr = this.titleList
      let  b =''
      arr.forEach(e => {
        if(e.dictValue==ids){
          b=e.dictLabel
        }
      });
     
      
      return b
    },
      sxtitle(e){
      let a =''
       
      if(this.inle=='zh'){
        a=e.dictLabel
      }
    if(this.inle=='en'){
      if(e.dictLabelEn.indexOf(":") !== -1){
       
        let c =JSON.parse(e.dictLabelEn)
     
        a=c.en
      }else{
        a=e.dictLabelEn
      }
      

      }
      if(this.inle=='de'){
         if(e.dictLabelEn.indexOf(":") !== -1){
             let d =JSON.parse(e.dictLabelEn)
a=d.de
         } else{
        a=e.dictLabelEn
      } 
         
      
      }
      return a

    },
   
   
    searchType (tab, event) {
      this.action = tab.label
      // console.log(tab);

      this.formInline.category = this.titleList[tab.index].dictValue
      this.biao()
    },
    search () {
      this.biao()
    },
    async biao () {
      let param = new URLSearchParams();
      let title = this.formInline.title;
      let type = this.formInline.type;
      let retailerId = this.formInline.retailerId;
     

      const { data: res } = await InvoiceOfDealer(
        param,
       title,
        type,
        retailerId,
       
        this.currentPage3,
        this.pagesize,
       
        
      );

      this.mation = res.rows.filter(item => item.status != 0);
      this.totale = res.total;
    },

    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
      this.pagesize=val
      this.biao()
    },
    handleCurrentChange (val) {
      this.currentPage3=val
      this.biao();
    },

    base64Encode(e){
  var rv;
  rv = encodeURIComponent(e);
  rv = unescape(rv);
  rv = window.btoa(rv);
  return rv;
},
    downurl (row, e) {
      this.txtUrl = ''
      this.videoUrl = ''
      this.typ = e
      console.log(123,row,e);

        let a =sessionStorage.getItem('i18n')
    
          this.ylTitle = row.title
      
   
      // this.aurl='https://view.officeapps.live.com/op/view.aspx?src=https://dms.bendamoto.com/bendaFDMSWeb' + row.filePath
      // this.aurl = 'https://view.bendamoto.com/onlinePreview?url='+encodeURIComponent(this.base64Encode(row.filePath))

this.aurl =row.url

      if (e == 'txt') {
        // axios.get('https://dms.bendamoto.com/bendaFDMSWeb' + row.filePath, { responseType: 'text' })
        axios.get( row.url, { responseType: 'text' })
          .then(response => {
            // 根据设置的编码进行处理，这里假定utf-8
            this.txtUrl = response.data;
          })

      }
      if (e == 'mp4') {
        // this.videoUrl = 'https://dms.bendamoto.com/bendaFDMSWeb' + row.filePath
        this.videoUrl = row.url
      }
      if (e == 'pdf') {
        // this.videoUrl = 'https://dms.bendamoto.com/bendaFDMSWeb' + row.filePath
        

// var url = row.filePath; //要预览文件的访问地址
// window.open('http://127.0.0.1:8012/onlinePreview?url='+encodeURIComponent(Base64.encode(previewUrl)));
        // this.videoUrl = 'https://view.bendamoto.com/onlinePreview?url='+encodeURIComponent(this.base64Encode(row.filePath))
        this.videoUrl = row.url
        console.log(123,this.videoUrl);
        
      }
      if (e == 'PDF') {
        // this.videoUrl = 'https://dms.bendamoto.com/bendaFDMSWeb' + row.filePath
        

// var url = row.filePath; //要预览文件的访问地址
// window.open('http://127.0.0.1:8012/onlinePreview?url='+encodeURIComponent(Base64.encode(previewUrl)));
        // this.videoUrl = 'https://view.bendamoto.com/onlinePreview?url='+encodeURIComponent(this.base64Encode(row.filePath))
        this.videoUrl = row.url
        console.log(123,this.videoUrl);
        
      }
      if (e == 'png' || e == 'jpg' || e == 'jepg') {
        // this.videoUrl = 'https://dms.bendamoto.com/bendaFDMSWeb' + row.filePath
        this.imgurl = row.url
      }
      console.log(123, this.imgurl);
      this.dialogVisible = true
    },
    downLoad (row) {
      console.log(row)
      // const fileURL = 'https://dms.bendamoto.com/bendaFDMSWeb' + row.filePath; // 替换为你的文件URL
      const fileURL =  row.url; // 替换为你的文件URL
      // console.log(fileURL)
      // const link = document.createElement('a');
      // // 这里是将链接地址url转成blob地址，
      // fetch(fileURL).then(res => res.blob()).then(blob => {
      //   link.href = URL.createObjectURL(blob)
      //   // 下载文件的名称及文件类型后缀
      //   link.download = `${row.fileName} ` + '.' + this.typ;
      //   document.body.appendChild(link)
      //   link.click()
      //   //在资源下载完成后 清除 占用的缓存资源
      //   window.URL.revokeObjectURL(link.href);
      //   document.body.removeChild(link);
      // });

      const src = `${fileURL}?t=${new Date().getTime()}`
      fetch(src).then(res => {
        res.blob().then(myBlob => {
          const href = URL.createObjectURL(myBlob)
          const a = document.createElement('a')
          a.href = href
          a.download = `${row.fileName} ` + '.' + this.typ;
          a.click()
          a.remove()
        })
      })
    

    }
  },
};
</script>

<style lang="less" scoped>
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.cinput {
  width: 300px;
  margin-right: 10px;
}

.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}

.bonntbot {
  display: flex;
  justify-content: space-between;
  align-items: center;

}

.bottompage {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

/deep/.el-table {
  min-height: 750px !important;
}

/deep/.el-table__body td {
  padding: 20px !important;
  padding-left: 0 !important;
  text-align: left;
}

/deep/.el-table th.is-leaf {
  text-align: left;
}

/deep/.el-tabs {
  height: 97%;
  width: 100%;
}

/deep/.el-tabs__content {
  width: 100%;
  height: 100%;
}

/deep/.el-table--scrollable-x .el-table__body-wrapper {
  height: 90%;
}

/deep/.el-tab-pane {
  height: 82%;
}

/deep/.el-table--fit {
  height: 94%;
}

.xz-box {
  width: 400px;
  margin: 0 auto;
}

.btn {
  display: flex;
  justify-content: space-evenly;
  color: #31aff2;
}

/deep/.el-dialog__body {
  overflow: auto;
}

.title {
  padding-bottom: 10px;


  .status {
    display: flex;
    margin-top: 20px;

    div {
      margin-right: 25px;
      cursor: pointer;
    }
  }
}
a{text-decoration:none;color: #409EFF;}
 
a:hover{text-decoration:underline}
</style>